export const MATERIAL_TYPES = {
  video: "video/mp4",
  pdf: "application/pdf",
};
